import { AuthService } from './shared/services/auth.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { TokenStorage } from './core/token.storage';
import { NetworkService } from './shared/services/network.service';
import { NotificationService } from './shared/services/notification.service';
import   FontFaceObserver from 'fontfaceobserver';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { ProgressLoaderService } from 'lib-sspcommon';
import { filter } from 'rxjs/operators';
import { CloudPrintRuntimeService } from './shared/services/cloud-print-runtime.service';
import { SSPCommonruntimeService } from './shared/services/sspcommon-runtime.service';
import MiscUtilService from './layout/rmm/services/utils/misc-util.service';
import { TenantService } from './shared/services/tenant.service';
import { DealerHierarchyService } from './layout/rmm/divison-dashboard/services/dealer-hierarchy.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit,OnDestroy {
    sspTenantIdFromRouteUrl: string;
    private popStateHandler;
    ESIGNAGE_ROUTES = [
        '/signage/users',
        '/signage/usergroups',
        '/signage/panels',
        '/signage/groups',
        '/signage/adminusers',
        '/signage/tenant',
        '/signage/service-settings',
        '/signage/subscription',
        '/signage/adminlogs',
        '/signage/systemlogs',
        '/signage/downloads',
        '/signage/playerupdates',
        '/signage/contentlogs'
    ];
    constructor(
        public auth: AuthService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private token: TokenStorage,
        private networkService: NetworkService,
        private notificationService: NotificationService,
        private translate: TranslateService,
        private loaderService: ProgressLoaderService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
       // private gtmService: GoogleTagManagerService,
        private cpService: CloudPrintRuntimeService,
        private miscUtilService: MiscUtilService,
        private tenantService: TenantService,
        private divisionService: DealerHierarchyService,
        private sspcommonruntime:SSPCommonruntimeService) {
        // Initialize MiscUtilService with the translation service
        MiscUtilService.setTranslationService(this.translate);
        // Add region class to body element for styling
        document.body.classList.add(`${environment.stackRegion.toLowerCase()}`);
        let previousURL;
        let currentURL;
        this.loadTranslation();
        this.registerSVGIcons();
        this.networkService.setNetworkListener();
        this.replaceHttp();
        this.router.events
            .subscribe((routerEvent) => {
                if (routerEvent instanceof NavigationEnd) {
                    this.loaderService.hideNavigationProgress();
                    previousURL = routerEvent.url;
                    if (routerEvent.url !== '/callback' && !routerEvent.url.includes('/guestprovider') && routerEvent.url !== '/' && !routerEvent.url.includes('/customadminprovider')) {
                        this.token.setCurrentUrl(routerEvent.url);
                    }
                    if (this.auth.isLoggedIn && (sessionStorage.getItem('redirectURL') == sessionStorage.getItem('currentUrl'))) {
                        sessionStorage.removeItem('redirectURL')
                        sessionStorage.removeItem('redirectURLTenant')
                    }
                }
                this.SaveOriginalUrl();
                if (routerEvent instanceof NavigationCancel || routerEvent instanceof NavigationError) {
                    this.loaderService.hideNavigationProgress();
                }
                if (routerEvent instanceof NavigationStart) {
                    currentURL = routerEvent.url;
                    if (previousURL && previousURL == '/service') {
                        this.loaderService.showNavigationProgress();
                    }
                    if (!previousURL && currentURL == '/downloads') {
                        localStorage.setItem("navigate-download", "true");
                    }
                    if (!previousURL && this.ESIGNAGE_ROUTES.includes(currentURL)) {
                        localStorage.setItem("navigate-esignage", "true");
                        localStorage.setItem("esignageCurrentUrl",currentURL)
                    }
                    if (this.auth.isLoggedIn && currentURL === '/' && previousURL !== '/') {
                        this.router.navigate([previousURL]);
                    }

                    // SHPLT-10918 fix: fixed precedence bug and added cloudprint alongside
                    // rmm/capture so cloudprint deep links are captured as a redirect fallback.
                    if (currentURL !== '/' && (routerEvent.url || '').indexOf('/callback') < 0 && (currentURL.includes('rmm') || currentURL.includes('cloudprint') || currentURL.includes('capture')) && !currentURL.includes('sessionId')) {
                    // updating logic to store only clean URL required for redirect URl
                        let cleanUrl = ''
                        if (currentURL.includes("?tid=")) {
                            cleanUrl = currentURL.split("?tid=")[0];
                            sessionStorage.setItem('redirectURLTenant', currentURL.split("?tid=")[1])
                        } else {
                            cleanUrl = currentURL;
                        }
                        sessionStorage.setItem('redirectURL', cleanUrl)
                    }
                    // If feat_v33 is enabled, re-direct some of the routes
                    if (environment.optional && environment.optional.feat_v33 === "true") {
                        // old route: /spaces/spacedetail/...
                        // new rout3: /roomdetail/...
                        let targetUrl = routerEvent.url;
                        // old route: /roomlist => new route: /workspace-list
                        if (targetUrl === '/roomlist') {
                            this.router.navigate([`/workspace-list/`]);
                        }
                        if (targetUrl.indexOf('?')) {
                            targetUrl = targetUrl.split('?')[0];
                        }
                        const segments = targetUrl.split('/');
                        // console.log(`segments: [${segments.length}]: ${JSON.stringify(segments)}`);
                        if (routerEvent.url.indexOf("/spaces/spacedetail/") >= 0 && segments.length == 4) {
                            const wsId = segments[3];
                            this.router.navigate([`/workspace-details/${wsId}`]);
                        }
                        if (routerEvent.url.indexOf("/spaces/spacedetail/") >= 0 && (segments[4] == 'mfpagentsummary' || segments[4] == 'displayagentsummary')) {
                            const wsId = segments[3];
                            const forwardTo = segments[4]
                            this.router.navigate([`/workspace-details/${wsId}/${forwardTo}`]);
                        }

                    }
                }
            });
        // Comment out this method call if using
        // hash-based routing
        const query = window.location.search;
        const params = new URLSearchParams(query);

        const hash = window.location.hash.substring(1); // remove the '#' at the start
        const pathParams = new URLSearchParams(hash);
        const sessionId = pathParams.get("sessionId");
        const rmmid = pathParams.get("rmmid");
        
        // rmmurl is stored when EKM user accessing device info page.
        const rmmurl = sessionStorage.getItem('rmmurl');
        if (query.includes('code=') || (hash.includes('callback') && !query.includes('error=')) || (sessionId && rmmid) || rmmurl) {
            // This handles the callback and processes tokens
            auth.checkCallbackAfterLogin = true
            auth.handleAuthentication();
        } else if (query.includes('error=') && query.includes('error_description=')) {
            // Fire the login failure event
            localStorage.removeItem('calendarAccountInfo')
            auth.HandleUserLoginFailure(params);
        }

        // Uncomment this method call if using
        // hash-based routing
        // auth.handleAuthenticationWithHash();

        // Font Face Observer is a fast and simple web font loader. We are using  it to load fonts and customise our browser’s font loading behaviour.
        const materialIcons = new FontFaceObserver('Material Icons');
        materialIcons.load().then(() => { console.log('Material Icons are loaded'); });
    }

    /**
     * Reads the dealerNumber and divisionId straight out of the browser URL.
     * Matches URLs shaped like:
     *   .../third-party/<dealerNumber>/<divisionId>/rmm/...  (divisionId present)
     *   .../third-party/<dealerNumber>/rmm/...                (divisionId absent - division customer tenants)
     *
     * @returns dealerNumber/divisionId from the URL; either can be null if absent
     */
    private getThirdPartyRouteParams(): { dealerNumber: string | null; divisionId: string | null } {
        const currentPath = window.location.hash.replace(/^#/, '');
        const withDivision = currentPath.match(/\/third-party\/([^/]+)\/([^/]+)\/rmm(\/|$)/);
        if (withDivision) {
            return { dealerNumber: withDivision[1], divisionId: withDivision[2] };
        }
        const withoutDivision = currentPath.match(/\/third-party\/([^/]+)\/rmm(\/|$)/);
        return { dealerNumber: withoutDivision ? withoutDivision[1] : null, divisionId: null };
    }

    /**
     * Switches tenant (carrying the divisionId along, if given) when the URL points to a
     * different tenant than the signal. Otherwise, just sets the division context.
     */
    private applyTenantAndDivisionContext(sspTenantIdFromRouteUrl: string, sspTenantIdFromSignal: string, divisionId: string | null) {
        if (sspTenantIdFromRouteUrl && sspTenantIdFromSignal && sspTenantIdFromRouteUrl !== sspTenantIdFromSignal) {
            // Switching tenant and then redirect to current url (bookmark URL scenario)
            this.auth.switchTenantContext(sspTenantIdFromRouteUrl, "", divisionId, () => {
                this.auth.navigateToUrl(this.router.url);
            });
        } else if (window.location.hash.includes('/multiTenantDashboard')) {
            // TEMP: multiTenantDashboard carried previous division's id, so reset it to null
            this.auth.setDivisionContext(null);
        } else if (divisionId) {
            this.auth.setDivisionContext(divisionId);
        }
    }

    tenantCheckWithBookMarkURL() {
        const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        const isDirectAccess = navigationEntry?.type === 'navigate';
        if (isDirectAccess) {
            //ToDo: This code can be removed when active tenant concept is removed.
            this.activatedRoute.queryParamMap.subscribe(params => {
                this.sspTenantIdFromRouteUrl = params.get('sspTenantId');
                const sspTenantIdFromSignal = this.auth.targetSspTenantId();
                const { dealerNumber, divisionId } = this.getThirdPartyRouteParams();

                if (divisionId) {
                    this.applyTenantAndDivisionContext(this.sspTenantIdFromRouteUrl, sspTenantIdFromSignal, divisionId);
                } else if (dealerNumber) {
                    // Division customer tenants bookmark URLs without a divisionId segment - look it
                    // up by matching sspTenantId against the dealer's customers.
                    this.divisionService.getDealerCustomers(dealerNumber).subscribe((res: any) => {
                        const matchedCustomer = (res?.dealersCustomers || []).find((customer: any) => customer.sspTenantId === this.sspTenantIdFromRouteUrl);
                        this.applyTenantAndDivisionContext(this.sspTenantIdFromRouteUrl, sspTenantIdFromSignal, matchedCustomer?.divisionId || null);
                    });
                } else {
                    this.applyTenantAndDivisionContext(this.sspTenantIdFromRouteUrl, sspTenantIdFromSignal, null);
                }
            });
        }
    }

    ngOnInit() {

        // The popstate event is triggered when the user clicks the browser back button.
        // The below code listens to the popstate event and checks whether the URL is related
        // to Auth0 silent authentication flows such as callback or ?code=.
        //
        // These silent authentication flows are triggered during tenant switching.
        // Since the callback redirect URL and ?code= URLs do not have any UI,
        // the below code skips those Auth0 silent authentication URLs and navigates
        // to the previous valid URL available in the browser history.
        //
        // This prevents a blank page from being shown when the user clicks the
        // browser back button after tenant switching or when Auth0 silent
        // authentication occurs.
        this.popStateHandler = () => {
            const fullUrl =
                globalThis.location.pathname +
                globalThis.location.search +
                globalThis.location.hash;

            const isAuthUrl = fullUrl.includes('callback') || fullUrl.includes('code=') || fullUrl.includes('state=') || fullUrl === '/#/' || fullUrl === '/';
            if (isAuthUrl) {
                setTimeout(() => {
                    history.back();
                }, 0);
            }
        };
        // The popstate event is triggered when the user clicks the browser back button,
        // and the popStateHandler function will be executed.
        globalThis.addEventListener('popstate', this.popStateHandler);

        this.tenantCheckWithBookMarkURL()
        if (environment.googleTagEnable === 'true' && environment.stackRegion === 'EU' && environment.googleTagId !== '') {
            this.setUpAnalytics();
        }
        this.checkNetwork();
        //to update the title of the tab
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
        ).subscribe(() => {
            const rt = this.getChild(this.activatedRoute);
            rt.data.subscribe(data => {
                if(data.title){
                    this.titleService.setTitle(data.title)
                }
                else{
                    const browserTitle = environment.stackRegion.toLowerCase() === 'jp'  ? 'e-Signage SX - 管理ポータル' : 'Synappx Admin';
                    this.titleService.setTitle(browserTitle)
                }
            });
        });
    }

    setUpAnalytics() {
        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
                const gtmTag = {
                    event: 'page',
                    pageUrl: item.url,
                    pageTitle: item.url.split('/').pop()
                };

               // this.gtmService.pushTag(gtmTag);
            }
        });
    }

    getChild(activatedRoute: ActivatedRoute) {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }

    // this function is used to replace the http calls to https
    replaceHttp() {
        let hrefLink = window.location.href;
        if (hrefLink.split(':')[0] === 'http' && !hrefLink.includes('localhost')) {
            hrefLink = hrefLink.replace('http', 'https');
            window.location.replace(hrefLink);
        }
    }

    // CHECK NETWORK CONNECTION TOASTER
    checkNetwork() {
        this.networkService.online$.subscribe(res => {
            if (res === false) {
                this.notificationService.showNotification('NetworkDown', undefined, 'N/A', { verticalPosition: 'top', panelClass: 'warning' });
            } else {
                this.notificationService.snackBar.dismiss();
            }
        });
    }

    // checks and stores the URL if 'admin_consent' parameter is present
    SaveOriginalUrl() {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        const isAdminConsentPresent = searchParams.has('admin_consent');
        if (isAdminConsentPresent) {
            console.log('admin_consent parameter is present.');
            sessionStorage.setItem('adminConsentUrl', url.href); // Store the URL in sessionStorage
        }
    }

    // function to register the svg icons as mat icons
    registerSVGIcons() {
        const svgIconList = [
            { name: 'svg_casting', url: '../assets/images/icons/svg/icon_casting.svg' },
            { name: 'svg_display', url: '../assets/images/icons/svg/icon_displays.svg' },
            { name: 'svg_devices', url: '../assets/images/icons/svg/icon_devices.svg'},
            { name: 'svg_mfp_access', url: '../assets/images/icons/svg/icon_mfp_access.svg' },
            { name: 'svg_import', url: '../assets/images/icons/svg/icon_import.svg' },
            { name: 'display_agent', url: '../assets/images/icons/svg/icon_ws_display_agent_outline.svg' },
            { name: 'svg_id_card', url: '../assets/images/icons/svg/icon_id_card.svg' },
            { name: 'svg_mail_unverified', url: '../assets/images/icons/svg/icon_unverified_mail.svg' },
            { name: 'svg_mail_verified', url: '../assets/images/icons/svg/icon_verified_mail.svg' },
            { name: 'svg_icon_ws_bt_speaker', url: '../assets/images/icons/svg/icon_ws_bt_speaker.svg' },
            { name: 'svg_icon_ws_checkin', url: '../assets/images/icons/svg/icon_ws_checkin.svg' },
            { name: 'svg_icon_ws_display', url: '../assets/images/icons/svg/icon_ws_display.svg' },
            { name: 'svg_icon_ws_mfp', url: '../assets/images/icons/svg/icon_ws_mfp.svg' },
            { name: 'svg_mfp', url: '../assets/rmm/images/icons/svg/rmm_icon_mfp.svg' },
            { name: 'svg_create', url: '../assets/rmm/images/icons/svg/rmm_icon_create.svg' },
            { name: 'svg_rmm_mfp', url: '../assets/rmm/images/icons/svg/rmm_icon_alldevices.svg' },
            { name: 'svg_rmm_display', url: '../assets/rmm/images/icons/svg/rmm_icon_displays.svg' },
            { name: 'svg_eweb', url: '../assets/rmm/images/icons/svg/rmm_icon_eweb_Icon.svg' },
            { name: 'svg_devicecloning', url: '../assets/rmm/images/icons/svg/rmm_icon_device_cloning.svg' },
            { name: 'svg_createschedule', url: '../assets/rmm/images/icons/svg/rmm_icon_create_schedule.svg' },
            { name: 'svg_securitycontrol', url: '../assets/rmm/images/icons/svg/rmm_icon_security_control.svg' },
            { name: 'svg_createpolicy', url: '../assets/rmm/images/icons/svg/rmm_icon_create_policy.svg' },
            { name: 'svg_fleetreport', url: '../assets/rmm/images/icons/svg/rmm_icon_fleet_report.svg' },
            { name: 'svg_securityreport', url: '../assets/rmm/images/icons/svg/rmm_icon_security_report.svg' },
            { name: 'svg_rmm_agent', url: '../assets/rmm/images/icons/svg/rmm_icon_agent.svg' },
            { name: 'svg_rmm_emailalert', url: '../assets/rmm/images/icons/svg/rmm_icon_email.svg' },
            { name: 'svg_rmm_countervariation', url: '../assets/rmm/images/icons/svg/rmm_icon_countervariation.svg' },
            { name: 'svg_rmm_connectWise', url: '../assets/rmm/images/icons/svg/rmm_icon_connectWise.svg' },
            { name: 'svg_storagebackup', url: '../assets/rmm/images/icons/svg/rmm_icon_storage_backup.svg' },
            { name: 'svg_uni_mfp', url: '../assets/images/icons/svg/uniws/icon_ws_mfp.svg'},
            { name: 'svg_uni_collab', url: '../assets/images/icons/svg/uniws/icon_ws_collab.svg' },
            { name: 'svg_uni_checkin', url: '../assets/images/icons/svg/uniws/icon_ws_checkin.svg' },
            { name: 'svg_uni_display', url: '../assets/images/icons/svg/uniws/icon_ws_display.svg' },
            { name: 'svg_uni_display_go', url: '../assets/images/icons/svg/uniws/icon_ws_display_go.svg' },
            { name: 'svg_uni_display_cast', url: '../assets/images/icons/svg/uniws/icon_ws_display_cast.svg' },
            { name: 'svg_uni_display_cast_go', url: '../assets/images/icons/svg/uniws/icon_ws_display_cast_go.svg' },
            { name: 'svg_uni_display_go_disable', url: '../assets/images/icons/svg/uniws/icon_ws_display_go_disable.svg' },
            { name: 'svg_uni_display_cast_disable', url: '../assets/images/icons/svg/uniws/icon_ws_display_cast_disable.svg' },
            { name: 'svg_uni_display_cast_disable_go', url: '../assets/images/icons/svg/uniws/icon_ws_display_cast_disable_go.svg' },
            { name: 'svg_uni_display_cast_go_disable', url: '../assets/images/icons/svg/uniws/icon_ws_display_cast_go_disable.svg' },
            { name: 'svg_icon_ws_casting', url: '../assets/images/icons/svg/uniws/icon_ws_casting.svg' },
            { name: 'svg_customtype', url: '../assets/rmm/images/icons/svg/rmm_icon_customdevicetype.svg' },
            { name: 'svg_technicalservice', url: '../assets/rmm/images/icons/svg/rmm_icon_technicalservice.svg' },
            { name: 'svg_servicereport', url: '../assets/rmm/images/icons/svg/rmm_icon_servicereport.svg' },
            { name: 'svg_alert', url: '../assets/rmm/images/icons/svg/rmm_icon_alert.svg' },
            { name: 'svg_getdata', url: '../assets/rmm/images/icons/svg/rmm_icon_getdata.svg' },
            { name: 'svg_remotemaintenance', url: '../assets/rmm/images/icons/svg/rmm_icon_remotemaintenance.svg' },
            { name: 'svg_firmwareupdate', url: '../assets/rmm/images/icons/svg/rmm_icon_firmwareupdate.svg' },
            { name: 'svg_customname', url: '../assets/rmm/images/icons/svg/rmm_icon_customname.svg' },
            { name: 'svg_removecustomname', url:'../assets/rmm/images/icons/svg/rmm_icon_remove_customname.svg'},
            { name: 'svg_removeschedule', url:'../assets/rmm/images/icons/svg/rmm_icon_device_remove_schedule.svg'},    
            { name: 'svg_rmm_dashboard', url: '../assets/rmm/images/icons/svg/rmm_icon_dashboard.svg' },
            { name: 'svg_rmm_powerinputschedule', url: '../assets/rmm/images/icons/svg/rmm_icon_powerinput_schedule.svg' },
            { name: 'svg_rmm_ceojuice', url: '../assets/rmm/images/icons/svg/rmm_icon_ceo_juice.svg' },
            { name: 'svg_firmwareupdate2', url: '../assets/rmm/images/icons/svg/rmm_icon_firmwareupdate.svg' },
            { name: 'svg_tasks', url: '../assets/rmm/images/icons/svg/rmm_icon_tasks.svg' },
            { name: 'svg_delete_cloningfile', url: '../assets/rmm/images/icons/svg/rmm_icon_delete_file.svg' }, 
            { name: 'svg_filter', url: '../assets/rmm/images/icons/svg/rmm_icon_filter.svg' },
            { name: 'svg_rmm_security', url: '../assets/rmm/images/icons/svg/rmm_icon_security.svg' },
            { name: 'svg_rmm_rop', url: '../assets/rmm/images/icons/svg/rmm_icon_rop.svg' },
            { name: 'svg_rmm_analytics', url: '../assets/rmm/images/icons/svg/rmm_icon_analytics.svg' },
            { name: 'svg_rmm_about', url: '../assets/rmm/images/icons/svg/rmm_icon_about.svg' },
            { name: 'svg_rmm_setting_download', url: '../assets/rmm/images/icons/svg/rmm_icon_setting_download.svg' },
            { name: 'svg_rmm_setting', url: '../assets/rmm/images/icons/svg/rmm_icon_setting.svg' },
            { name: 'svg_rmm_system', url: '../assets/rmm/images/icons/svg/rmm_icon_system.svg' },
            { name: 'svg_rmm_log', url: '../assets/rmm/images/icons/svg/rmm_icon_log.svg' },
            { name: 'svg_rmm_download', url: '../assets/rmm/images/icons/svg/rmm_icon_download.svg' },
            { name: 'svg_rmm_delete', url: '../assets/rmm/images/icons/svg/rmm_icon_delete.svg' },
            { name: 'svg_rmm_edit', url: '../assets/rmm/images/icons/svg/rmm_icon_edit.svg' },
            { name: 'svg_rmm_status_update', url: '../assets/rmm/images/icons/svg/rmm_icon_status_update.svg' },
            { name: 'svg_rmm_mail', url: '../assets/rmm/images/icons/svg/rmm_icon_mail.svg' },
            { name: 'svg_rmm_refresh', url: '../assets/rmm/images/icons/svg/rmm_icon_refresh.svg' },
            { name: 'svg_rmm_add', url: '../assets/rmm/images/icons/svg/rmm_icon_add.svg' },
            { name: 'svg_rmm_remove', url: '../assets/rmm/images/icons/svg/rmm_icon_remove.svg' },
            { name: 'svg_rmm_evatic', url: '../assets/rmm/images/icons/svg/rmm_icon_evatic.svg' },
            { name: 'svg_addressbook', url: '../assets/rmm/images/icons/svg/rmm_icon_address_book.svg' },
            { name: 'svg_rmm_service_ai_sidebar', url: '../assets/rmm/images/icons/svg/rmm_icon_service_ai_sidebar.svg' },
            { name: 'svg_rmm_service_ai', url: '../assets/rmm/images/icons/svg/rmm_icon_service_ai.svg' },
            { name: 'rmm_icon_service_ai_black', url: '../assets/rmm/images/icons/svg/rmm_icon_service_ai_black.svg' },
            { name: 'healthcard', url: '../assets/rmm/images/icons/svg/rmm_icon_healthcard.svg' },
            { name: 'svg_mfp_communication', url: '../assets/rmm/images/icons/svg/rmm_ icon_mfp_communication.svg' },
            { name: 'svg_mfp_security', url: '../assets/rmm/images/icons/svg/rmm_icon_mfp_security.svg' },
            { name: 'svg_mfp_toner', url: '../assets/rmm/images/icons/svg/rmm_icon_mfp_toner.svg' },
            { name: 'svg_mfp_service_ai_send', url: '../assets/rmm/images/icons/svg/rmm_service_ai_send.svg' },
            { name: 'svg_rmm_service_ai_clear', url: '../assets/rmm/images/icons/svg/icon_clean_Ai_content.svg' },
            { name: 'svg_rmm_service_ai_sidebar_collapsed', url: '../assets/rmm/images/icons/svg/rmm_service_ai_sidebar_collapsed.svg' },
            { name: 'svg_rmm_azure_entraid', url: '../assets/rmm/images/icons/svg/rmm_icon_azure_entraid.svg' },
            { name: 'svg_tenant_service_access', url: '../assets/images/icons/svg/icon_service_access.svg' },
            { name: 'rmm_icon_micas', url: '../assets/rmm/images/icons/svg/rmm_icon_micas.svg' },
            { name: 'svg_rmm_icon_edit_divisions', url: '../assets/rmm/images/icons/svg/rmm_icon_edit_divisions.svg' },
            { name: 'svg_rmm_icon_mfp_direct_device', url: '../assets/rmm/images/icons/svg/rmm_icon_mfp_direct_device.svg' },
            { name: 'svg_rmm_icon_agent_registered_device', url: '../assets/rmm/images/icons/svg/rmm_icon_agent_registered_device.svg' },
            {name:'svg_rmm_ftp',url:'../assets/rmm/images/icons/svg/icon_ftp_server.svg'},
            {name:'svg_rmm_icon_assign_devices',url:'../assets/rmm/images/icons/svg/rmm_icon_assign_devices.svg'}

];
        svgIconList.forEach((icon)  => {
            this.matIconRegistry.addSvgIcon(
                icon.name,
                this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url),
            );
        });
    }

    //Supporting languages code list
    loadTranslation(): any {
        let browserLang = this.translate.getBrowserLang();
        let supportedLanguages = ['en'];
        if (environment.stackRegion == "EU") {
            supportedLanguages = ['da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'pl', 'sv'];
            // check only for norwegien
            const norLangCode = ['no', 'nb', 'nn'];
            if (norLangCode.includes(browserLang)) {
                browserLang = 'no';
            }
            // set browserlang to spanish if catalan or spanish is selected
            const spanishLangCode = ['ca', 'es'];
            if (spanishLangCode.includes(browserLang)) {
                browserLang = 'es';
            }
            browserLang = supportedLanguages.includes(browserLang) ? browserLang : 'en';
            this.translate.use(browserLang);
        } else if (environment.stackRegion == "JP") {
            supportedLanguages = ['en', 'ja'];
            browserLang = supportedLanguages.includes(browserLang) ? browserLang : 'en';
            this.translate.use(browserLang);
        } else {
            browserLang = 'en';
            this.translate.use(browserLang);
        }
        return browserLang;
    }

    ngOnDestroy(): void {
        // The popstate event is triggered when the user clicks the browser back button,
        // and the popStateHandler function will be executed.
        globalThis.removeEventListener('popstate', this.popStateHandler);
    }

}
